<template>
  <Academica :url="url"/>
</template>
<script>
import Cookies from "js-cookie";
import K2Row from "../uiComponents/k2Row/k2Row";
import K2Heading from "../uiComponents/k2Heading/k2Heading";
import uiVariable from "../config/uiVariable";
import {lang} from "@/locale";
import Academica from "./academica/Academica";

export default {
  name: "DailyRoutine2",
  components: { Academica },
  data() {
    return {
      uiVariable: uiVariable,
      url:""
    };
  },
  mounted() {
    this.url = 'https://academica.etonhouse.com/headless/dailylogs/'+Cookies.get("schoolSession")+'/'+Cookies.get("userIDSession")
  },
  methods: {
    lang,
  }
};
</script>